import { Link } from "react-router-dom";
import { Reveal } from "../components/Reveal";
import Seo from "../components/Seo";

export default function ThankYou() {
    return (
        <div data-testid="page-thank-you" className="pt-32">
            <Seo
                title="Thank You — Inquiry Received"
                description="Thank you for reaching out to Vyom Tex Linen. We have received your inquiry and will respond within two working days."
                path="/thank-you"
                noIndex
            />

            <section className="container-vyom min-h-[70vh] flex flex-col justify-center pb-24">
                <Reveal>
                    <div className="text-[14px] uppercase tracking-overline text-vyom-mute mb-10">
                        Inquiry received
                    </div>
                </Reveal>

                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-end">
                    <div className="md:col-span-8">
                        <Reveal delay={0.05}>
                            <h1 className="font-serif-display text-5xl md:text-7xl lg:text-[96px] leading-[0.98] tracking-tight">
                                Thank you. We will be{" "}
                                <span className="italic">in touch</span>{" "}
                                shortly.
                            </h1>
                        </Reveal>
                    </div>
                    <div className="md:col-span-4 md:col-start-9">
                        <Reveal delay={0.15}>
                            <p className="text-[19px] leading-relaxed text-vyom-mute max-w-md">
                                Your message has reached our studio in
                                Coimbatore. A member of our team will respond
                                within two working days.
                            </p>
                            <p className="mt-6 text-[15px] leading-relaxed text-vyom-mute max-w-md">
                                In the meantime, you may continue exploring
                                the collections, or write to us directly at{" "}
                                <a
                                    href="tel:+918220055388"
                                    className="text-vyom-ink link-underline"
                                >
                                    +91 82200 55388
                                </a>
                                .
                            </p>
                        </Reveal>
                    </div>
                </div>

                <Reveal delay={0.25}>
                    <div className="mt-16 md:mt-24 flex flex-col sm:flex-row gap-6 sm:gap-10 items-start sm:items-center">
                        <Link
                            to="/"
                            data-testid="thankyou-home"
                            className="text-[13px] whitespace-nowrap uppercase tracking-overline border border-vyom-ink px-8 py-3.5 text-vyom-ink hover:bg-vyom-ink hover:text-vyom-bg transition-colors duration-500"
                        >
                            Return home
                        </Link>
                        <Link
                            to="/collections"
                            data-testid="thankyou-collections"
                            className="text-[13px] whitespace-nowrap uppercase tracking-overline text-vyom-ink link-underline"
                        >
                            Continue to The Collections
                        </Link>
                    </div>
                </Reveal>
            </section>
        </div>
    );
}
